import React from 'react';

import {
    AbilityLookup,
    Action,
    DataOriginRefData,
    Feat,
    FeatUtils,
    RuleData,
    SnippetData,
    Spell,
    CharacterTheme,
} from '@dndbeyond/character-rules-engine/es';

import { FeatFeatureSnippet } from '../FeatureSnippet';

interface Props {
    feats: Array<Feat>;
    onActionUseSet: (action: Action, uses: number) => void;
    onActionClick: (action: Action) => void;
    onSpellClick: (spell: Spell) => void;
    onSpellUseSet: (spell: Spell, uses: number) => void;
    onFeatureClick: (feature: Feat) => void;
    snippetData: SnippetData;
    ruleData: RuleData;
    abilityLookup: AbilityLookup;
    dataOriginRefData: DataOriginRefData;
    isReadonly: boolean;
    proficiencyBonus: number;
    theme: CharacterTheme;
}
export default class FeatsDetail extends React.PureComponent<Props> {
    renderFeats = (): React.ReactNode => {
        const { feats, ...restProps } = this.props;

        return (
            <React.Fragment>
                {feats.map((feat) => (
                    <FeatFeatureSnippet {...restProps} key={FeatUtils.getId(feat)} feat={feat} feats={feats} />
                ))}
            </React.Fragment>
        );
    };

    renderDefault = (): React.ReactNode => {
        const { theme } = this.props;
        return (
            <div
                className={`ct-feats-detail__default ${theme?.isDarkMode ? 'ct-feats-detail__default--dark-mode' : ''}`}
            >
                <p>You have no feats chosen, you can add feats outside of normal progression in the manage screen.</p>
            </div>
        );
    };

    render() {
        const { feats } = this.props;

        return <div className="ct-feats-detail">{feats.length ? this.renderFeats() : this.renderDefault()}</div>;
    }
}
